import React from 'react';
import styled from 'styled-components';
import { useLoginWithAbstract } from '@abstract-foundation/agw-react';
import { useAccount } from 'wagmi';
import { NavButtonStyle } from './styles/ButtonStyles';

const ButtonContainer = styled.div`
  ${props => props.$position === 'header' ? `
    /* No absolute positioning needed when in header */
  ` : props.$position === 'center' ? `
    margin-top: 20px;
  ` : ''}
`;

// Use the shared NavButtonStyle
const NavButton = styled(NavButtonStyle)``;

export default function ConnectWalletButton({ position = 'center' }) {
  const { login, logout } = useLoginWithAbstract();
  const { status, address } = useAccount();
  
  if (status === "connecting" || status === "reconnecting") {
    return (
      <ButtonContainer $position={position}>
        <NavButton>Connecting...</NavButton>
      </ButtonContainer>
    );
  }

  if (address) {
    return (
      <ButtonContainer $position={position}>
        <NavButton onClick={logout}>Disconnect Wallet</NavButton>
      </ButtonContainer>
    );
  }

  return (
    <ButtonContainer $position={position}>
      <NavButton onClick={login}>Connect Wallet</NavButton>
    </ButtonContainer>
  );
}
